/**
 * Scroll to Top Action
 * Triggered by: arc:action:scrollToTop
 *
 * Scrolls the window to the top smoothly.
 * Usage: window.dispatchEvent(new CustomEvent('arc:action:scrollToTop', { detail: { duration: 500 } }))
 */

export const runScrollToTop = async (data = {}) => {
  try {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    return {
      success: true
    };
  } catch (error) {
    console.error('runScrollToTop error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export default runScrollToTop;
